import moment from 'moment';

export const DATE_MIN = moment('2000-01-01');
export const DATE_MAX = moment('2035-12-31');
